export const st2110 = {
  st2110: {
    dropdown: {
      statistics: 'STATISTICS',
      allOutputs: 'All Outputs',
      noOutputs: 'Select Type',
      mediaTypes: {
        video: 'Video',
        audio: 'Audio',
        data: 'ANC',
      },
      title: {
        all: 'All Outputs',
        custom: 'Selection',
      },
      label: 'Outputs',
    },
    name: '{{type}} Output {{output}}',
    notice: 'Outputs are currently managed by the NMOS service. ',
    noticeLink: 'View Services',
    mediaTypesName: {
      video: 'Video',
      audio: 'Audio',
      data: 'Anc',
    },
    tableHeader: {
      streamName: 'Stream Name',
      connection: 'Connection',
      protocol: 'Protocol',
      status: 'Status',
    },
    enums: {
      state: {
        0: 'STOPPED',
        1: 'STARTED',
      },
    },
    fields: {
      address: 'Address',
      //ancData: 'ANC Data',
      multicastAddress: 'Multicast Address',
      numOfChannels: 'Number of Channels',
      numOfChannelsExplain: '1 - 16',
      packetTimeMismatch: 'Actual {{actual}} (more than 10 channels decoded)',
      packetTime: 'Packet Time',
      port: 'Port',
      portExplain: '1 - 65535',
      payload: 'Payload',
      rtpPayload: 'RTP Payload',
      rtpPayloadExplain: '0 - 127',
      type: 'Media Type',
      ttl: 'TTL',
      tos: 'ToS',
      ttlExplain: '1 - 255',
      tosExplain: '0x00 - 0xFF',
    },
    mediaTypes: {
      video: 'Video',
      audio: 'Audio',
      data: 'ANC',
    },
    outputs: {
      1: '2110 OUTPUT 1',
      2: '2110 OUTPUT 2',
      3: '2110 OUTPUT 3',
      4: '2110 OUTPUT 4',
    },
    sections: {
      path1: 'Path 1',
      st2110: 'ESSENCE',
      settings: 'SETTINGS',
    },
    states: {
      failed: 'FAILED',
      running: 'Streaming',
      stopped: 'Stopped',
    },
    noContent: {
      title: 'No NMOS Outputs',
      subText: 'Make sure your personality is 2110 and reboot',
    },
    noFitleredContent: {
      title: 'No Outputs to Show',
      subText: 'Select at least one output from dropdown.',
    },
    noNameData: 'ANC',
    notifications: {
      resetStatsError: 'Output statistics could not be reset',
      resetStatsError_plural: 'Outputs statistics could not be reset',
      resetSelectedSuccess: "The selected output's statistics have been reset",
      resetSelectedSuccess_plural: 'The selected outputs statistics have been reset',
      createError: 'Output could not be created',
      createSuccess: 'Output created successfully',
      deleteError: 'Output could not be removed',
      deleteError_plural: '{{count}} outputs could not be removed',
      deleteSuccess: 'Output deleted successfully',
      startError_plural: '{{count}} outputs could not be started',
      startError: '{{count}} output could not be started',
      startSuccess: "Output '{{name}}' started successfully",
      startSuccess_plural: '{{count}} outputs started successfully',
      startSuccessEmptyName: 'Output started successfully',
      stopError_plural: '{{count}} outputs could not be stopped',
      stopSuccess: "Output '{{name}}' updated successfully",
      stopSuccessEmptyName: 'Output updated successfully',
      stopSuccess_plural: '{{count}} outputs stopped',
      stopError: '{{count}} output could not be stopped',
      updateError: "Output '{{name}}' updated successfully",
      updateErrorEmptyName: 'Output could not be updated',
      updateSuccess: "Output '{{name}}' updated successfully",
      updateSuccessEmptyName: 'Output updated successfully',
    },
    lastReset: 'Last Reset',
    RESETSTATS: 'Reset Stats',
    resetStatistics: 'Reset Statistics',
    unnamedSt2110: '{{type}} {{output}}',
    statistics: {
      mediaType: 'Media Type',
      st2110: 'STATISTICS - SMPTE ST 2110',
      streamSync: 'Stream Sync',
      txPackets: 'TX Packets',
      videoFormatDetectionState: 'Video Format Detection',
      detectedVideoFormat: 'Detected Video Format',
    },
  },
};
